import { useApi } from '@/api';
import { Page, PageSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import EventsTable from './EventsTable';

export default function UpgradeUSDSActivityPage() {
  const { pagination, sorting } = useTableProps({
    pageSize: 20,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: `/upgrade/usds/events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Heading size="1">
            <Flex
              flexBasis="100%"
              gap={['xs', '2xs']}
              flexDirection={['column', 'row']}>
              <CryptoIcon
                name={'USDS'}
                address={tokensMapping('USDS').address}
                size="3"
              />
              {data.symbol} Activity
            </Flex>
          </Heading>
        }>
        <EventsTable data={data} sorting={sorting} pagination={pagination} />
      </Page>
    );
  }

  return <PageSkeleton />;
}
